import React, { useEffect, useRef, useState } from 'react'
import Pagination from '../Pagination/Pagination'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { useSelector } from 'react-redux'
import { getCurrentUserData, RootState } from '../../Redux/store'
import SingleValueReportVU from '../Reports/SingleValueReportVU'
import useStickyHeader from '../../Hooks/useStickyHeader'
interface ISortConfig {
    key: null | number
    direction: 'asc' | 'desc'
}

interface ITableDataAsJSON {
    Content: any[]
    Headers: string[]
}

export const ReportTable = (props: {
    MeasureList?:{ [s: string]: any }[]
    vuId: any
    yAxisList: any[]
    xAxisList:any[]
    openDrillThru: (cellInfo: any, cell: any, row: any, rowIndex: any) => void,
    drillThruDPList: any[]
    tableJSOnData: { [s: string]: any }
    setTableJSOnData: (data: { [s: string]: any }) => void
    AllowDrillThru: string
}) => {
    const {MeasureList, vuId, yAxisList,xAxisList, openDrillThru, drillThruDPList, tableJSOnData, setTableJSOnData,AllowDrillThru } =
        props
    const formTableValues = (data: any, minLength: number, isDynamicHeaders: boolean) => {
        //FP-12095 isDynamicHeaders flag required because, we are not accepting data points to show in table whose array length is less than Headers
        // if headers are 3, data point should be 3 not less than 3
        //It failse for F_V23_CONFIG_PAWAN_NEW => Measure - case1 = total, filter- Casaed Edited - Has Valid Date, Organise columns, Case Edited - Year, Case  Edited - Month
        const result = []
        let startIndex = 0
        const content = data?.Content || []
        for (const outItr of content) {
            const { length } = outItr
            const skipIterations = (isDynamicHeaders && length === minLength) ||
            (!isDynamicHeaders && length < minLength)

            if (skipIterations) continue //FP-12095

            const metaData = drillThruDPList?.slice(startIndex, startIndex + length - minLength)
            // Update startIndex
            startIndex += length - minLength

            // Add transformed row to result
            result.push({ data: outItr, metaData })
        }
        return result
    }

    const [headerMapperArray, setHeaderMapperArray] = useState<undefined[]>([])

    const formArrayForHeaderMapping = (xAxisList: any[], yAxisList: any[]) => {
        let headerArray: any[] = [] //filling array with number values, we need length to form headers FP-12093
        //In Ticket- FP-12093, Tested for every combination of xAxisList and yAxisList
        if (xAxisList?.length === 1 && yAxisList?.length === 0) {
            // 1 X 0
            headerArray = Array.from({ length: yAxisList.length + 1 }, (_, i) => i)

        } else if( xAxisList?.length === 0 && yAxisList?.length === 1) {
            // 0 X 1
            headerArray = Array.from({ length: yAxisList.length + 1}, (_, i) => i)

        }else if (xAxisList?.length === 1 && yAxisList?.length === 1) {
            // 1 X 1
            headerArray = Array.from({ length: yAxisList.length + 1 }, (_, i) => i)

        }else if (xAxisList?.length === 2 && yAxisList?.length === 0) {
            // 2 X 0
            headerArray = Array.from({ length: yAxisList.length + 1 }, (_, i) => i)

        } else if (xAxisList?.length === 0 && yAxisList?.length === 2) {
            // 0 X 2 //TODO:
            headerArray = Array.from({ length: yAxisList.length}, (_, i) => i) //here in this case length should be equal to yAxisList.length, no column division of headers

        } else if (xAxisList?.length === 2 && yAxisList?.length === 1) {
            // 2 X 1
            headerArray = Array.from({ length: yAxisList?.length + 1 }, (_, i) => i)

        } else if (xAxisList?.length === 1 && yAxisList?.length === 2) {
            // 1 X 2
            headerArray = Array.from({ length: yAxisList?.length + 1 }, (_, i) => i)

        }else if (xAxisList?.length === 2 && yAxisList?.length === 2) {
            // 2 X 2
            headerArray = Array.from({ length: yAxisList?.length + 1 }, (_, i) => i)
        }else{
            throw new Error('Invalid X-Axis and Y-Axis combination')
        }
        setHeaderMapperArray(headerArray)
    }

    useEffect(() => {
        formArrayForHeaderMapping(xAxisList, yAxisList)
        let ComputedData: any = tableJSOnData?.ComputedData
        if (ComputedData) {
            createVuTableData(ComputedData)
        } else {
            createVuTableData(tableJSOnData)
        }
    }, [tableJSOnData])

    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))
    const [sortConfig, setSortConfig] = useState<ISortConfig>({ key: null, direction: 'asc' })
    const getPageSize = useSelector((state: RootState) => state.pagination.rowsPerPage)
    const [tableHeaderData, setTableHeaderData] = useState<any[]>([])
    const [tableFooterData, setTableFooterData] = useState<string[]>([])
    const [isDynamicHeaders, setIsDynamicHeaders] = useState<boolean>(false)

    // const minLengthRef = useRef()
    const [paginatedRows, setPaginatedRows] = useState<any[]>([]) //must be set in useEffect only
    const [staticHeaders, setStaticHeaders] = useState<string[]>([])
    const [tableRowData, setTableRowData] = useState<any[]>([])
    const handleSort = (columnIndex: number) => {
        const direction =
            sortConfig.key === columnIndex && sortConfig.direction === 'asc' ? 'desc' : 'asc'
        setSortConfig({ key: columnIndex, direction })

        const sortedRows = [...tableRowData].sort((a, b) => {
            const cellA = a.data[columnIndex]
            const cellB = b.data[columnIndex]

            // Function to extract numeric and string parts
            const getSortableValue = (value: any) => {
                if (typeof value === 'string') {
                    // If it contains numbers, extract the numeric part, otherwise return the string itself
                    const numericPart = parseInt(value.replace(/\D/g, ''), 10)
                    const stringPart = value.replace(/[0-9]/g, '').toLowerCase() // Extracts the alphabetic part
                    return { stringPart, numericPart: isNaN(numericPart) ? Infinity : numericPart } // Defaults numericPart to Infinity if not found
                }
                return { stringPart: '', numericPart: Number(value) } // For numeric values
            }

            const valA = getSortableValue(cellA)
            const valB = getSortableValue(cellB)

            if (valA.stringPart < valB.stringPart) return direction === 'asc' ? -1 : 1
            if (valA.stringPart > valB.stringPart) return direction === 'asc' ? 1 : -1

            // If string parts are the same, sort by numeric part
            return direction === 'asc'
                ? valA.numericPart - valB.numericPart
                : valB.numericPart - valA.numericPart
        })
        setPaginatedRows(sortedRows.slice(0, getPageSize || 10))
        const updatedTableJSONData = {
            ...tableJSOnData,
            Content: sortedRows.map((row) => row.data),
        }
        setTableJSOnData(updatedTableJSONData)
    }
   

    const createVuTableData = (ComputedData: any) => {
        // if(isSvrReport){
        //     setTableRowData(ComputedData)
        //     return
        // }
        let minLength = 0
        if (ComputedData?.Headers == undefined) {
            let staticFormedData = [{ data: [ComputedData?.MeasureName, ComputedData?.DataPoint] }]
            setTableFooterData([])
            setTableHeaderData([])
            setIsDynamicHeaders(false)
            setPaginatedRows(staticFormedData)
        } else {
            setTableHeaderData(ComputedData?.Headers)
            setTableFooterData(ComputedData?.Footers || [])
            const staticHeadersVal = ComputedData?.Headers.filter(
                (item: any) => typeof item === 'string'
            )
            const dynamicHeaders = ComputedData?.Headers.some(
                (item: any) => typeof item === 'object'
            )
            if (dynamicHeaders) {
                minLength = staticHeadersVal?.length ?? 0
            }
            setIsDynamicHeaders(dynamicHeaders)
            let tableContentDpList = formTableValues(ComputedData, staticHeadersVal?.length ?? 0, dynamicHeaders)
            setStaticHeaders(staticHeadersVal)
            setPaginatedRows(tableContentDpList?.slice(0, 10))
            setTableRowData(tableContentDpList)
        }
    }
    const [isDrillThruAllowed, setIsDrillThruAllowed] = useState(false);
    useEffect(() => {            
    let allowed = true;
    if (AllowDrillThru === "N") {
      allowed = false;
    }
    for (const measure of MeasureList ?? []) {
      if (
        measure.FactTableName === "Computed" ||
        measure.FactTableName === "BPComputed" ||
        measure.FactTableName === "SVRComputed" ||
        measure.MetaData?.DrillThruType === ""
      ) {
        allowed = false;
        break;
      }
    }
    if (!currentUserData?.privileges.includes("AllowDrillThruLaunch")) {
      allowed = false;
    }
    setIsDrillThruAllowed(allowed);       
    }, [AllowDrillThru, MeasureList, currentUserData?.privileges])
    const tableRef = useRef<HTMLTableElement>(null);
    const pageContainerRef = useRef<HTMLDivElement>(null); 
    useStickyHeader(tableRef, pageContainerRef);

    return (
        <>
            <div className="vu-table-wrapper" id={'React_vu_table_wrapper_' + vuId}  ref={pageContainerRef}>
                <table
                    className="vu-table focus-highlight hover-highlight tablesorter tablesorter-default tablesorter9a4d7ef687657"
                    id={'vu_table_' + vuId}
                    ref={tableRef}
                >
                    <thead style={{ position: 'relative', top: '0px' }}>
                        {headerMapperArray.map((_, yIndex) => ( //FP-12093- For every combinatino yAxis length + 1 does not work, added separate functions to handle this, used as Row span as well
                            <tr
                                className="vu-header-row tablesorter-headerRow"
                                key={`header_row_${yIndex}_${vuId}`}
                            >
                                {tableHeaderData?.map(
                                    (
                                        headerItem: string | { [s: string]: any },
                                        arrayIndex: number
                                    ) => {
                                        // Static Headers (String Type)
                                        if (typeof headerItem === 'string' && yIndex == 0) {
                                            const isSortedColumn =
                                                sortConfig?.key === arrayIndex
                                            let isStaticHeaders = false
                                            const sortClass = isSortedColumn
                                                ? sortConfig.direction === 'asc'
                                                    ? 'tablesorter-headerAsc'
                                                    : 'tablesorter-headerDesc'
                                                : 'tablesorter-headerUnSorted'
                                            if (
                                                isDynamicHeaders &&
                                                staticHeaders?.includes(headerItem)
                                            ) {
                                                isStaticHeaders = true
                                            }
                                            let headerClasses =
                                                (isStaticHeaders &&
                                                    arrayIndex <= staticHeaders.length) ||
                                                (!isStaticHeaders && arrayIndex === 0)
                                                    ? `vu-fixed-cell ${sortClass}`
                                                    : `${sortClass}`
                                            return (
                                                <th
                                                    className={`${headerClasses} tablesorter-header-inner vu-mark-cell vu-sort-cell sorter-vurow-fixedcolumn-sorter tablesorter-header`}
                                                    key={`static_header_${arrayIndex}`}
                                                    rowSpan={headerMapperArray.length}
                                                    onClick={() => handleSort(arrayIndex)}
                                                >
                                                    <strong>{headerItem.replace(/_+/g, ' ')}</strong>
                                                </th>
                                            )
                                        }
                                        // Dynamic Headers (Object Type)
                                        else if (
                                            typeof headerItem === 'object' &&
                                            typeof headerItem !== 'string'
                                        ) {
                                            const key = Object.keys(headerItem)[0] // "0", "1", "2", etc.
                                            const innerArray = headerItem[key] // Array of headers (Contractor, Management)
                                            // Render dynamically for all valid keys
                                            return (
                                                <React.Fragment
                                                    key={`dynamic_header_${key}_${arrayIndex}`}
                                                >
                                                    {innerArray.map(
                                                        (
                                                            innerHeader: any,
                                                            innerIndex: number
                                                        ) => {
                                                            const headerName =
                                                                Object.keys(innerHeader)[0] // e.g., "Contractor", "Management"
                                                            const headerValue =
                                                                innerHeader[headerName][0] // e.g., "Total Scheduled Hours"
                                                            // Render headers based on yIndex
                                                            switch (yIndex) {
                                                                case 0: // Top-level headers ("0", "1", etc.)
                                                                    return innerIndex === 0 ? (
                                                                        <th
                                                                            className={`sorter-false vu-dim-val-cell vu-grp-cell vu-mark-cell tablesorter-header tablesorter-headerUnSorted`}
                                                                            style={{
                                                                                width: '96px',
                                                                            }}
                                                                            key={`top_level_${key}_${vuId}`}
                                                                            colSpan={
                                                                                innerArray.length
                                                                            }
                                                                            onClick={() => handleSort(innerIndex)}
                                                                        >
                                                                            {key}
                                                                        </th>
                                                                    ) : null

                                                                case 1: // Second-level headers ("Contractor", "Management")
                                                                    return (
                                                                        <th
                                                                            className={`sorter-false vu-dim-val-cell vu-mark-cell tablesorter-header tablesorter-headerUnSorted`}
                                                                            key={`second_level_${key}_${innerIndex}`}
                                                                            colSpan={1}
                                                                            onClick={() => handleSort(innerIndex)}
                                                                        >
                                                                            {typeof innerHeader ===
                                                                            'object'
                                                                                ? headerName
                                                                                : innerHeader}
                                                                        </th>
                                                                    )

                                                                case 2: // Third-level headers ("Total Scheduled Hours")
                                                                    return (
                                                                        <th
                                                                            className={`sorter-false vu-mark-cell tablesorter-header tablesorter-headerUnSorted`}
                                                                            key={`third_level_${key}_${innerIndex}`}
                                                                            colSpan={1}
                                                                            onClick={() => handleSort(innerIndex)}
                                                                        >
                                                                            {headerValue}
                                                                        </th>
                                                                    )

                                                                default:
                                                                    return <></>
                                                            }
                                                        }
                                                    )}
                                                </React.Fragment>
                                            )
                                        } else return <></>
                                    }
                                )}
                            </tr>
                        ))}
                    </thead>

                    {/* New Code */}
                    <tbody>
                        {paginatedRows.map((row: any, rowIndex: number) => {
                            return (
                                <tr className="vu-data-row" key={rowIndex}>
                                    {row?.data?.map((cell: string, cellIndex: number) => {
                                        let isStaticHeaders = false
                                        const cellWithPercentage = cell?.split(' ')
                                        if (isDynamicHeaders && staticHeaders?.includes(cell)) {
                                            isStaticHeaders = true
                                        }
                                        let rowClasses =
                                            (isStaticHeaders &&
                                                cellIndex <= staticHeaders.length) ||
                                            (!isStaticHeaders && cellIndex === 0)
                                                ? `vu-fixed-cell vu-mark-cell`
                                                : AllowDrillThru == 'Y' && currentUserData.privileges.includes('AllowDrillThruLaunch')
                                                    ? `vu-drill-cell`
                                                    : `vu-no-drill-cell`;
                                                // : `vu-drill-cell`
                                        return cellWithPercentage?.length === 2 &&
                                            cellIndex !== 0 ? (
                                            <td
                                                id={
                                                    
                                                        `td_${vuId}_${rowIndex + 1}_${cellIndex}`
                                                }
                                                onClick={() => {
                                                    rowClasses !== `vu-drill-cell`
                                                        ? null
                                                        : openDrillThru(
                                                            drillThruDPList.find((meta: any) => {
                                                                return meta?.cellId === `${vuId}_${rowIndex + 1}_${(xAxisList.length === 1 && yAxisList.length === 1 ? cellIndex - 1 : cellIndex)}`
                                                            }), // Temproary fix to make things work. I saw the code and I think we need to refactor this code properly.
                                                                cell,
                                                                row,
                                                                rowIndex
                                                            )
                                                }}
                                                className={rowClasses}
                                                key={cellIndex}
                                            >
                                                {cellWithPercentage[0].trim()}
                                                <span className="vu-per-data">
                                                    {cellWithPercentage[1] || ''}
                                                </span>
                                            </td>
                                        ) : (
                                            <td
                                                id={
                                                
                                                        `td_${vuId}_${rowIndex + 1}_${cellIndex}`
                                                }
                                                onClick={() => {
                                                    rowClasses !== `vu-drill-cell`
                                                        ? null
                                                        : openDrillThru(
                                                            drillThruDPList.find((meta: any) => {
                                                                return meta?.cellId === `${vuId}_${rowIndex + 1}_${(xAxisList.length === 1 && yAxisList.length === 1 ? cellIndex - 1 : cellIndex)}`
                                                            }),
                                                                cell,
                                                                row,
                                                                rowIndex
                                                            )
                                                }}
                                                className={rowClasses}
                                                key={cellIndex}
                                            >
                                                {cell}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                    {tableFooterData.length > 0 && (
                        <tfoot>
                            <tr className="vu-total-row">
                                {tableFooterData.map((footer: string, footerIndex: number) => {
                                    const cellWithPercentage = footer.split(' ')
                                    let isStaticHeaderCell = false
                                    if (
                                        isDynamicHeaders &&
                                        footerIndex <= staticHeaders?.length
                                    ) {
                                        isStaticHeaderCell = true
                                    } else if (footerIndex === 0) {
                                        isStaticHeaderCell = true
                                    }

                                    return cellWithPercentage.length === 2 &&
                                        isStaticHeaderCell ? (
                                        <td
                                            className={
                                                isStaticHeaderCell
                                                    ? 'vu-fixed-cell vu-grand-cell vu-mark-cell'
                                                    : isDrillThruAllowed
                                                    ? 'vu-grand-cell vu-drill-cell'
                                                    : `vu-no-drill-cell` 
                                            }
                                            key={footerIndex}
                                        >
                                            {cellWithPercentage[0]}{' '}{cellWithPercentage[1]}
                                        </td>
                                    ) : (
                                        <td
                                        id={
                                                    
                                            `td_${vuId}_-1_-1`
                                    }
                                                className={
                                                    isStaticHeaderCell
                                                        ? 'vu-fixed-cell vu-grand-cell vu-mark-cell'
                                                        : isDrillThruAllowed
                                                            ?
                                                            'vu-grand-cell vu-drill-cell'
                                                            : 'vu-grand-cell vu-no-drill-cell'
                                                }
                                    
                                            key={footerIndex}
                                        
                                            onClick={
                                                isDrillThruAllowed
                                                    ? () => {
                                                        const matchedMeta = drillThruDPList.find((meta: any) => {
                                                            return meta?.cellId === `${vuId}_-1_-1`;
                                                            });
                                                        
                                                            if (matchedMeta) {
                                                            const { vuDeId, meId, dimDPs } = matchedMeta;
                                                            openDrillThru(matchedMeta,footer, vuDeId, meId);
                                                            }
                                                        }
                                                    : undefined
                                            }
                                        >
                                            {footer}
                                        </td>
                                    )
                                })}
                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>
            {/* Pagination */}
            {tableRowData?.length > 10 && (
                <Pagination
                    orgArray={tableRowData}
                    totalRows={tableRowData?.length}
                    setPaginatedRowsState={setPaginatedRows}
                />
            )}
            {tableRowData?.length <= 10 && (
                <>
                    <div id={`vu_paging_wrapper_${vuId}`} className='vu-paging-wrapper tablesorter-pager'>
                        <div className="left"></div>
                        <div className="right">
                            <span className='padding-left-largest'>{tableRowData?.length} {tableRowData?.length === 1 ? 'row' : 'rows'}</span>
                        </div>
                    </div>
                    <div className='clear-both'></div>
                </>
            )}
        </>
    )
}
